<template>
  <div class="bulk-status-editor">
    <h2 class="editor-header">{{ $t('orders.bulk_change_status') }}</h2>
    <div class="row">
      <div class="form-group">
        <label class="form-label">{{ $t('orders.select_state') }}</label>
        <multiselect
          v-model="selectedStatus"
          :options="orderStatusValues"
          :custom-label="value => getStatusString(value)"
          :searchable="false"
          :placeholder="$t('orders.select_status')"
          :select-label="$t('orders.select_state')"
          :selected-label="$t('common.selected')"
          :deselect-label="$t('common.remove_selection')"
        />
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary form-button" @click="$emit('close')">
        {{ $t('common.cancel') }}
      </button>
      <button type="button" class="btn btn-primary form-button" :disabled="selectedStatus === null" @click="save">
        {{ $t('common.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import { orderStatus, workManagementHelper } from '@/components/mixins/WorkManagementMixin'
import Multiselect from 'vue-multiselect'

export default {
  name: 'BulkStatusEditor',
  components: { Multiselect },
  mixins: [workManagementHelper],
  emits: ['save', 'close'],
  data() {
    return {
      selectedStatus: null
    }
  },
  computed: {
    orderStatusValues() {
      return Object.values(orderStatus)
    }
  },
  methods: {
    save() {
      this.$emit('save', this.selectedStatus)
    }
  }
}
</script>

<style scoped>
.bulk-status-editor {
  width: 100%;
}
.form-group {
  margin-bottom: 1rem;
}
.form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}
.modal-footer {
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
</style>
